import React from "react";
import { useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useForm } from '@formspree/react';

const Contact = () => {
    const [state, handleSubmit, reset] = useForm('mbljyvgg');
    const [visible, handleVisible] = useState('hidden')

    if (state.succeeded) {
        reset();
        handleVisible('');
    }

    return (
        <div className="animate-fade">
            <Header />
            <div className="z-[-1] mt-[60px] lg:mt-auto m-0 h-full lg:h-screen flex flex-col lg:flex-row">
                <div className="z-[-1] flex flex-col w-screen lg:h-[60vh] bg-ocean opacity-85 text-left">
                    <div className="ml-[4em]">
                        <h1 className="mt-[5em] font-bold text-[2em] leading-[1.7em] text-white">Contact Us</h1>
                        <p className="w-full lg:w-[50%] text-[1em] leading-[1.7em] mt-[2em] text-white">Fill out the information and an ALKOR representative will reach out to you.</p>
                        <p className="w-full lg:w-[50%] mb-[5em] text-[1em] leading-[1.7em] text-white">We look forward to hearing from you!</p>
                    </div>
                </div>

                <div className="z-30 flex flex-col justify-center items-center text-[0.9em]">
                    <form onSubmit={handleSubmit} className="lg:absolute lg:right-24 lg:top-40 p-[2em] lg:border bg-white rounded lg:border-[2px] lg:border-slate lg:shadow-lg lg:shadow-2xl lg:shadow-gray">
                        <div className="flex flex-row my-[1em]">
                            <div className="flex flex-col ml-[1em] mr-[1.5em]">
                                <label name="name" className="font-medium">Name *</label>
                                <input className="border border-[1.5px] rounded border-[lightgray]" required type="text" name="name" />
                            </div>
                            <div className="flex flex-col">
                                <label className="font-medium">Email *</label>
                                <input className="border border-[1.5px] rounded border-[lightgray]" required type="email" name="email" />
                            </div>
                        </div>
                        <div className="flex flex-col ml-[1em] mr-[1.5em]">
                            <label className="font-medium">How did you hear about us? *</label>
                            <textarea className="border border-[1.5px] rounded border-[lightgray]" required rows="4" cols="43" name="source"></textarea>
                        </div>
                        <div className="flex flex-col ml-[1em] mr-[1.5em] mt-[1em]">
                            <label className="font-medium">What would you like to discuss? *</label>
                            <textarea className="border border-[1.5px] rounded border-[lightgray]" required rows="4" cols="43" name="message"></textarea>
                        </div>
                        <div className="flex flex-col justify-center">
                            <p className={`text-center my-[1em] ${visible}`}>Thank you! Your submission has been received.</p>
                        </div>
                        <button disabled={state.submitting} className="block bg-navy opacity-70 text-white mx-auto border rounded mb-[2em] mt-[1em] px-[1em] py-[0.5em]" type="submit">Submit</button>
                    </form>
                </div>
            </div >
            <Footer />
        </div >
    );
};

export default Contact;




